/** Базовый URL REST API чат-сервера (без завершающего слэша). */
export function getChatApiBaseUrl() {
  if (import.meta.env.VITE_CHAT_API_URL) {
    return import.meta.env.VITE_CHAT_API_URL.replace(/\/$/, '');
  }
  if (typeof window === 'undefined') {
    return 'http://127.0.0.1:3001/api';
  }
  // dev: Vite проксирует /api/chat → chat_server; prod: nginx → /chat-api/
  const base = import.meta.env.DEV
    ? `${window.location.origin}/api`
    : `${window.location.origin}/chat-api`;
  return base.replace(/\/$/, '');
}
